<div [innerHtml]="evaluatedAgendaItem"></div>
<div *ngIf="activity">
  <wm-form-activity-input-view
    [activity]="activity"
    [form]="form"
    [applicationId]="applicationId"
  ></wm-form-activity-input-view>
</div>
